import React, { FC } from 'react'
import { Trans, t } from '@lingui/macro'
import { Table, Tbody, Td, Tr } from '@chakra-ui/react'
import {
  Box,
  Link,
  Modal,
  Spinner,
  ButtonClean,
  ButtonDanger
} from 'front-end/src/components'
import {
  RelatedCampaignDetailsFragment,
  useEmailIdentityRelatedCampaignsQuery
} from './RemoveEmailIdentityModal.codegen'
import { linkBuilder } from '../../../../../shared/linkBuilder'

export const RemoveEmailIdentityModal = ({ sender, resolve, reject }) => {
  const { data, loading } = useEmailIdentityRelatedCampaignsQuery({
    variables: { id: sender.id }
  })
  const relatedCampaigns =
    data?.admin?.organisation?.emailIdentity?.relatedCampaigns ?? []

  const defaultEmailIdentity =
    data?.admin?.organisation?.defaultOrganisationEmailIdentity?.email

  const isUsed = !!relatedCampaigns.length

  return (
    <Modal
      newDesign
      header={t`Are you sure you want to remove this sender?`}
      controls={
        <>
          <ButtonClean onClick={reject}>
            <Trans>Cancel</Trans>
          </ButtonClean>
          <ButtonDanger onClick={resolve}>
            <Trans>Remove</Trans>
          </ButtonDanger>
        </>
      }
      onHide={reject}
    >
      {loading ? (
        <Spinner />
      ) : isUsed ? (
        <>
          <p>
            <Trans>
              This email address is being used in some{' '}
              <strong>Campaigns</strong>. Removing this sender will apply the
              first email sender
              {defaultEmailIdentity ? ` () ` : ' '} as the default email sender
              for the following campaigns. Please make sure you’re happy to
              proceed.
            </Trans>
          </p>

          <RelatedCampaignsListWithAuthors campaigns={relatedCampaigns} />
        </>
      ) : (
        <Trans>
          You can always re-add senders. If a sender address was verified, no
          further verification will be required.
        </Trans>
      )}
    </Modal>
  )
}

export const RelatedCampaignsListWithAuthors: FC<{
  campaigns: Array<RelatedCampaignDetailsFragment>
}> = ({ campaigns: items }) => (
  <Box maxHeight="400px" overflow="scroll">
    <Table size="sm">
      <Tbody>
        {items.map((campaign) => (
          <Tr key={campaign.id}>
            <Td>
              <Link to={linkBuilder.campaign(campaign.id)} target="_blank">
                <span className={'Modal__relatedItems__importantInfo'}>
                  <strong>{campaign.name}</strong>{' '}
                </span>
                {campaign.author && (
                  <small>
                    (<Trans>by</Trans> {campaign.author.email})
                  </small>
                )}
              </Link>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  </Box>
)
